<div class="calendar-filter-status" (click)="editFilter()">
    <span>Viewing: </span>
    <span>{{ countryString }}</span> |
    <span>{{ topicString }}</span>
</div>
<button mat-button (click)="editFilter()" class="calendar-filter-button">Edit</button>
